import { useEffect } from "react";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    const set = (selector, content) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute("content", content);
    };
    if (description) {
      set('meta[name="description"]', description);
      set('meta[property="og:description"]', description);
    }
    set('meta[property="og:title"]', title);
  }, [title, description]);
}
